import Box from '@mui/material/Box';
import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';
import { NotFoundScreen } from '../../components/alliance/system-screens';

/**
 * Unknown routes render the 404 inside the shell (the App Bar stays usable)
 * instead of silently redirecting. Used for `*` at the top level and inside
 * the admin and account sections. It skips RouteContainer, so no footer
 * sits around the screen.
 */
export function NotFound() {
  // Hooks
  const navigate = useNavigate();

  return (
    <Box role="main">
      <Helmet>
        <title>Alliance Events · Page not found</title>
      </Helmet>

      <NotFoundScreen onHome={() => navigate('/')} />
    </Box>
  );
}
